import React from "react";
import PropTypes from "prop-types";
import "./FaqContactModal.scss";
import Modal from "react-modal";
import { FormattedMessage } from "react-intl";
import HelpDeskPhoneNumberContainer from "app/pages/.shared/HelpDeskPhoneNumber/HelpDeskPhoneNumberContainer";
import Separator from "app/pages/.shared/Separator";
import HelpDeskPhoneNumber from "app/pages/.shared/HelpDeskPhoneNumber/HelpDeskPhoneNumber";

const style = {
	overlay: {
		backgroundColor: "rgba(43, 56, 63, .9)",
		zIndex: 5,
	},
};

const FaqContactModal = ({ isOpen, servicesPhone, onClose }) => {
	return (
		<Modal
			style={style}
			isOpen={isOpen}
			shouldCloseOnOverlayClick={true}
			shouldCloseOnEsc={true}
			onRequestClose={onClose}
			className="faq-contact-modal__content"
		>
			<div className="faq-contact-modal">
				<div className="faq-contact-modal__close">
					<i className="icon icon--cross-dark" onClick={onClose} />
				</div>
				<div className="faq-contact-modal__title">
					<FormattedMessage id="faq.contact.services.title" /> :
				</div>
				<HelpDeskPhoneNumberContainer showPicto={true} />
				{servicesPhone.servicesDialPhone && (
					<div className="faq-contact-modal__sales">
						<Separator design="middle" />
						<div className="faq-contact-modal__title">
							<FormattedMessage id="faq.contact.sales.title" /> :
						</div>
						<HelpDeskPhoneNumber
							displayInternationalPhone={
								servicesPhone.servicesDisplayInternationalPhone
							}
							internationalDialPhone={servicesPhone.servicesInternationalDialPhone}
							dialPhone={servicesPhone.servicesDialPhone}
							displayPhone={servicesPhone.servicesDisplayPhone}
							officeHours={servicesPhone.officeHours}
						/>
					</div>
				)}
			</div>
		</Modal>
	);
};

FaqContactModal.propTypes = {
	isOpen: PropTypes.bool,
	servicesPhone: PropTypes.object,
	onClose: PropTypes.func,
};

FaqContactModal.defaultProps = {
	onClose: () => {},
	servicesPhone: {},
};

export default React.memo(FaqContactModal);
